import { arrayOf, exact, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const availableDateFieldsType = arrayOf(
  exact({
    label: string,
    value: string,
  })
);
